import React from 'react';

import { Flex } from '@adsk/alloy-react-box';
import { displayDate, VALID_DATE_FORMATS } from '@adsk/alloy-react-datetime';
import Divider from '@adsk/alloy-react-divider';

import { useTaskLocale } from '../../../hooks';
import { Task } from '../../../types';

interface PlanTaskEntityBlockDateSummaryProps {
  task: Task;
}

const PlanTaskEntityBlockDateSummary = ({
  task,
}: PlanTaskEntityBlockDateSummaryProps) => {
  const { T } = useTaskLocale();

  const calculateDateRange = () => {
    if (!task.plannedStart || !task.plannedDuration) {
      return null;
    }

    const startDate = new Date(task.plannedStart);

    const displayedStartDate = displayDate(startDate, {
      format: VALID_DATE_FORMATS.NUMERIC,
    });

    return T.translate('PLAN_TASK_DATE', {
      startDate: displayedStartDate,
    });
  };

  if (!task.plannedStart || !task.plannedDuration) {
    return null;
  }

  const displayedDateRange = calculateDateRange();
  const displayedDays =
    task.plannedDuration > 1 ? T.translate('DAYS') : T.translate('DAY');
  const displayedDuration = `${task.plannedDuration} ${displayedDays}`;

  return (
    <Flex alignItems="center" style={{ gap: '12px' }}>
      <div>{displayedDateRange}</div>
      <Divider
        variant={Divider.VARIANTS.VERTICAL}
        color={Divider.COLORS.DARK}
        height={12}
      />
      <div>{displayedDuration}</div>
    </Flex>
  );
};

export default PlanTaskEntityBlockDateSummary;
